import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import moment from "moment";
import CustomDatePicker from "./component/Custom-Datepicker";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Custom column widths
const columnStyles = {
  checkbox: { width: "40px" },
  employeeName: { width: "160px" },
  presentDays: { width: "20px" },
  workingDays: { width: "30px" },
  invoicedDays: { width: "50px" },
  InvoiceNo: { width: "120px" },
  tmpBasicAmount: { width: "80px" },
  default: { width: "90px" },
  remarks: { width: "120px" }
};

const customStyle = {
  formControl: {
    width: "100%", // Will inherit from parent td width
    fontSize: "11px",
    borderRadius: "4px",
    padding: "5px 5px 5px 6px",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    color: "#212529",
    border: "1px solid #ced4da",
  },
  formCheckInput: {
    margin: "0",
  },
};

const customDatePickerStyle = {
  control: "custom-datepicker-control",
  menu: "custom-datepicker-menu",
  option: "custom-datepicker-option",
  input: "custom-datepicker-input",
};

const InvoiceRow = ({
  data,
  index,
  isSelected,
  onCheckboxChange,
  onFieldChange,
  onDateChange,
  projectallocationOption,
}) => {
  const { register, watch, setValue, getValues } = useForm({
    defaultValues: {
      InvoicedDays: data?.InvoicedDays || "0",
      AdjustmentAmount: data?.AdjustmentAmount || "",
      TaxPercent: data?.TaxPercent || "",
      ExchangeRate: data?.ExchangeRate || "",
      InvoiceNo: data?.InvoiceNo || "",
      Remarks: data?.Remarks || "",
    },
  });

  // Watch relevant fields for calculations
  const basicAmount = parseFloat(data?.BasicAmount) || 0;
  const adjustmentAmount = parseFloat(watch("AdjustmentAmount")) || 0;
  const taxPercent = parseFloat(watch("TaxPercent")) || 0;
  const exchangeRate = parseFloat(watch("ExchangeRate")) || 1;

  // Calculate derived values
  const invoiceAmount = basicAmount + adjustmentAmount;
  const invoiceWithTax = invoiceAmount + (invoiceAmount * taxPercent) / 100;
  const invoiceCalculatedAmount = (invoiceWithTax * exchangeRate).toFixed(2);

  // Handle field changes
  const handleChange = (e, fieldName) => {
    const value = e.target.value;
    setValue(fieldName, value);
    onFieldChange(index, fieldName, value);
  };

  // Handle date changes
  const handleDatePickerChange = (value, fieldName) => {
    onDateChange(value, index, fieldName);
  };

  // Update parent when calculated values change
  useEffect(() => {
    onFieldChange(index, "InvoiceAmount", invoiceAmount);
    onFieldChange(index, "InvoiceCalculatedAmount", invoiceCalculatedAmount);
  }, [invoiceAmount, invoiceCalculatedAmount, index, onFieldChange]);

  return (
    <tr className="border">
      {/* Checkbox column */}
   
      <td style={columnStyles.checkbox}>
        <input
          type="checkbox"
          style={customStyle.formCheckInput}
          checked={isSelected}
          onChange={(e) => onCheckboxChange(e, index, data)}
        />
      </td>

      {/* Employee Name - 100px */}
          <OverlayTrigger
                                      
                                      placement="right"
                                      overlay={
                                        <Tooltip>
                                          {data?.tmpEmployeeName}
                                        </Tooltip>
                                      }
                                    >
      <td style={columnStyles.employeeName}>
        <input
          type="text"
          style={customStyle.formControl}
          disabled
          value={data?.tmpEmployeeName || ""}
        />
      </td>
</OverlayTrigger>
      {/* Present Days - 60px */}
      <td style={columnStyles.presentDays}>
        <input
          type="text"
          disabled
          className="text-end"
          style={customStyle.formControl}
          value={data?.PresentDays || ""}
        />
      </td>

      {/* Working Days - 60px */}
      <td style={columnStyles.workingDays}>
        <input
          type="number"
          disabled
          className="text-end"
          style={customStyle.formControl}
          value={data?.WorkingDays || ""}
        />
      </td>

      {/* Invoiced Days - 60px */}
<td style={columnStyles.invoicedDays}>
        <input
          type="text"
          className="text-end"
          style={customStyle.formControl}
          {...register("InvoicedDays")}
          onChange={(e) => handleChange(e, "InvoicedDays")}
        />
      </td>

      {/* Invoice Rate Freq - 90px */}
      <td style={columnStyles.default}>
        <input
          disabled
          type="text"
          style={customStyle.formControl}
          value={data?.tmpInvoiceRateFreq || ""}
          readOnly
        />
      </td>

      {/* Invoice From Date - 90px */}
      <td style={columnStyles.default}>
        <CustomDatePicker
          wrapperClassName="invoice-date-picker"
          readOnly
          size="sm"
          value={
            data?.InvoiceFromDate
              ? moment(data?.InvoiceFromDate).format("DD-MMM-YYYY")
              : ""
          }
        />
      </td>

      {/* Invoice To Date - 90px */}
      <td style={columnStyles.default}>
        <CustomDatePicker
          wrapperClassName="invoice-date-picker"
          style={customDatePickerStyle}
          readOnly
          value={
            data?.InvoiceToDate
              ? moment(data?.InvoiceToDate).format("DD-MMM-YYYY")
              : ""
          }
        />
      </td>

      {/* Basic Amount - 90px */}
      <td style={columnStyles.tmpBasicAmount}>
        <input
          type="text"
          disabled
          className="text-end px-1"
          style={customStyle.formControl}
          value={data?.tmpBasicAmount || ""}
        />
      </td>

      {/* Adjustment Amount - 90px */}
      <td style={columnStyles.default}>
        <input
          type="text"
          style={customStyle.formControl}
          className="text-end"
          {...register("AdjustmentAmount")}
          onChange={(e) => handleChange(e, "AdjustmentAmount")}
        />
      </td>

      {/* Invoice Amount - 90px */}
      <td style={columnStyles.default}>
        <input
          type="text"
          style={customStyle.formControl}
          disabled
          className="text-end"
          value={invoiceAmount || ""}
        />
      </td>

      {/* Tax Percent - 90px */}
      <td style={columnStyles.default}>
        <input
          type="text"
          style={customStyle.formControl}
          className="text-end"
          {...register("TaxPercent")}
          onChange={(e) => handleChange(e, "TaxPercent")}
        />
      </td>

      {/* Exchange Rate - 90px */}
      <td style={columnStyles.default}>
        <input
          type="text"
          style={customStyle.formControl}
          className="text-end"
          {...register("ExchangeRate")}
          onChange={(e) => handleChange(e, "ExchangeRate")}
        />
      </td>

      {/* Invoice Calculated Amount - 90px */}
      <td style={columnStyles.default}>
        <input
          type="number"
          disabled
          className="text-end"
          style={customStyle.formControl}
          value={invoiceCalculatedAmount || ""}
        />
      </td>
      <td style={columnStyles.default}>
        <input
          type="number"
          disabled
          className="text-end"
          style={customStyle.formControl}
          value={data?.SoPoBalance || ""}
        />
      </td>

      {/* Invoice Date - 90px */}
      <td style={columnStyles.default}>
        <CustomDatePicker
          style={customDatePickerStyle}
          wrapperClassName="invoice-date-picker"
          value={
            data?.InvoiceDate
              ? moment(data?.InvoiceDate).format("DD-MMM-YYYY")
              : moment(new Date()).format("DD-MMM-YYYY")
          }
          handleChange={(value) => handleDatePickerChange(value, "InvoiceDate")}
          key={`invoice-date-${data?.InvoiceDate || 'default'}`}
        />
      </td>

      {/* Invoice No - 90px */}
      <td style={columnStyles.default}>
        <input
          type="text"
          style={customStyle.formControl}
          className="text-end"
          {...register("InvoiceNo", {
            required: "Invoice number is required",
            min: { value: 1, message: "Must be positive number" },
          })}
          onChange={(e) => handleChange(e, "InvoiceNo")}
        />
      </td>

      {/* Payment Term Days - 90px */}
      {/* <td style={columnStyles.default}>
        <input
          type="text"
          disabled
          style={customStyle.formControl}
          value={data?.PaymentTermDays || ""}
          className="text-end"
        />
      </td> */}

      {/* Payment Due Date - 90px */}
      <td style={columnStyles.default}>
        <CustomDatePicker
          readOnly
          wrapperClassName="invoice-date-picker"
          style={customDatePickerStyle}
          value={
            data?.PaymentDueDate
              ? moment(data?.PaymentDueDate).format("DD-MMM-YYYY")
              : ""
          }
        />
      </td>

      {/* Follow Up Date - 90px */}
      {/* <td style={columnStyles.default}>
        <CustomDatePicker
          value={
            data?.FollowUpDate
              ? moment(data?.FollowUpDate).format("DD-MMM-YYYY")
              : ""
          }
          wrapperClassName="invoice-date-picker"
          style={customDatePickerStyle}
          handleChange={(value) => handleDatePickerChange(value, "FollowUpDate")}
          key={`followup-date-${data?.FollowUpDate || 'empty'}`}
        />
      </td> */}

      {/* Payment Received Date - 90px */}
      {/* <td style={columnStyles.default}>
        <CustomDatePicker
          wrapperClassName="invoice-date-picker"
          value={
            data?.PaymentReceivedDate
              ? moment(data?.PaymentReceivedDate).format("DD-MMM-YYYY")
              : ""
          }
          style={customDatePickerStyle}
          handleChange={(value) => handleDatePickerChange(value, "PaymentReceivedDate")}
          key={`payment-received-${data?.PaymentReceivedDate || 'empty'}`}
        />
      </td> */}

      {/* Over Due Days - 90px */}
      {/* <td style={columnStyles.default}>
        <input
          type="text"
          disabled
          style={customStyle.formControl}
          className="text-end"
          value={data?.OverDueDays || ""}
        />
      </td> */}

      {/* Remarks - 120px */}
      <td style={columnStyles.remarks}>
        <input
          type="text"
          style={customStyle.formControl}
          {...register("Remarks")}
          onChange={(e) => handleChange(e, "Remarks")}
        />
      </td>
    </tr>
  );
};

InvoiceRow.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  projectallocationOption: PropTypes.array.isRequired,
};

export default React.memo(InvoiceRow);